import { useEffect } from 'react'
import Cube from '../assets/images/Cube.png'
import Dots from '../assets/images/Dots.png'
import Easel from '../assets/images/Easel.png'
import Laptop from '../assets/images/Laptop.png'
import Webflow from '../assets/images/Webflow.png'
import Circles from '../assets/images/Circles3.png'
import Starfish from '../assets/images/Starfish.png'
import AvatarPlaceholder from '../assets/images/AvatarPlaceholder.png'
import Consulting from '../assets/images/Consulting.png'
import TechConsulting from '../assets/images/Tech-Consulting.png'
import Entrprenuer from '../assets/images/Entrepreneurial-Hub.png'
import AvatarPlaceholder2 from '../assets/images/Placeholder2.png'
import Bulb from '../assets/images/Bulb.png'
import Hands from '../assets/images/Hands.png'
import Amalgam from '../assets/images/Amalgam-logo.png'

import LinkedIn from '../assets/images/LinkedIn.png'
import '../styles/ourwork.css'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import One from '../assets/images/One.png'
import Two from '../assets/images/Two.png'
import Three from '../assets/images/Three.png'
import Four from '../assets/images/Four.png'
import Five from '../assets/images/Five.png'
import Six from '../assets/images/Six.png'
import Blog1 from '../assets/images/blog-images/Blog1.png'
import Blog2 from '../assets/images/blog-images/Blog2.png'
import Blog3 from '../assets/images/blog-images/Blog3.png'
import Arrow from '../assets/images/Arrow1.png'

import { useMediaQuery } from 'react-responsive'

function Ourwork() {
    const navigate = useNavigate();
    const isMobile = useMediaQuery({ maxWidth: 570 });
    const isTablet = useMediaQuery({ maxWidth: 1100 });


    const { pathname } = useLocation();
    // useEffect(() => {
    //     window.scrollTo(0, 0); // Scroll to the top
    // }, [pathname]);
    return (
        <div style={{ boxSizing: "border-box", overflowX: "hidden" }}>
            <img src={Starfish} alt="Starfish" className='ourwork-starfish2' />
            <img src={Bulb} alt="Bulb" className='ourwork-bulb' />
            <div className='ourwork-row-1-background' style={{ position: "relative", zIndex: 1 , backgroundColor: "white"}}>
                <div className='ourwork-row-1'>
                    <div className='ourwork-row-1-left'>
                        <img src={Laptop} className='laptop' alt='Placeholder' />
                    </div>
                    <div className='ourwork-row-1-right'>
                        <h1 className='ourwork-row-1-right-header'>Tailored solutions for every<br className='ourwork-br-1' /> stage of your journey</h1>
                        <p className='ourwork-row-1-right-text'>We empower entrepreneurs to make a positive impact by growing their<br className='ourwork-br-1' /> business, adopting cutting-edge technology, and building the right <br className='ourwork-br-1' /> connections.</p>
                        <button className='ourwork-lets-talk'>Let's talk</button>

                    </div>
                </div>



                <img src={Dots} className='dots' alt='Placeholder' />
                <div className='ourwork-row-2'>

                    <div className='ourwork-row-2-container'>
                        <h1 className='ourwork-row-2-header'>How we do it</h1>
                        <p className='ourwork-row-2-text'>We leverage our highly specialized knowledge and deliver innovative solutions that address the needs of forward-thinking business owners. We support you as you build your products, scale your business, and grow your network with the right connections.</p>
                        <p className='ourwork-row-2-text'></p>
                    </div>
                </div>
            </div>

            <div className='ourwork-row-3'>
                <div className='ourwork-row-3-container'>
                </div>
            </div>

            <div className='ourwork-row-4'>
                <div className='ourwork-row-4-container'>
                    <div className='ourwork-row-4-left'>
                        <p className='ourwork-row-4-header'>You'll benefit from:</p>
                        <div className='ourwork-row-4-subheader'>
                            <p>Having a single point of reference for business and digitization support</p>
                        </div>
                        <div className='ourwork-row-4-subheader'>
                            <p>Custom solutions that meet your unique needs</p>
                        </div>

                        <div className='ourwork-row-4-subheader'>
                            <p>A wide network of visionary leaders, world-class consultants, and funders</p>
                        </div>
                    </div>

                    <div>
                        <img src={Easel} alt="" className='easel' />
                    </div>

                </div>
            </div>

            {/* <section className='ourwork-row-6'>
                <h1>You can count on us for your:</h1>
                <div className='ourwork-row-6-content-container'>
                    <div className='ourwork-row-6-content'>
                        <h4>Business consulting</h4>
                        <p>Our experienced team of consultants is ready to guide you through every step of your business journey, from growth advice to rebranding and beyond.</p>
                    </div>
                    <div className='ourwork-row-6-content'>
                        <h4>Bespoke tech solutions</h4>
                        <p>We empower you with a wide range of bespoke tech solutions with transparent value, from custom software development to generative AI.</p>
                    </div>
                    <div className='ourwork-row-6-content'>
                        <h4>Entrepreneurial hub</h4>
                        <p>We're your bridge to top-tier consultants, forward-thinking business owners, funders, and investors.</p>
                    </div>
                </div>
            </section> */}


            {/* <section className='ourwork-row-7'>
                <h1>We meet you where you are</h1>
                <div>
                    <p>From your business's conceptual phase to the realization of your most ambitious plans, our end-to-end solution gets you where you want to be. At what stage of your journey are you?</p>
                    <button onClick={() => navigate('/startups')}>I'm a startup</button>
                </div>

            </section> */}

            <section className='ourwork-row-8'>
                <div>
                    <h1>How we've helped other businesses</h1>
                    <p>Our case studies will give you clear insights into how we've been able to help companies like yours in the past.</p>
                </div>
            </section>

            <section>
                <div className='blog-row-3-article-row' id='ourwork-row-9'>
                    <div className='blog-row-3-card' id='ourwork-row-9-card' style={{ display: 'flex', justifyContent: 'center' }}>
                        <Link to="/case-studies/pfa" style={{ textDecoration: 'none', cursor: 'pointer', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <img src={Blog1} alt="Placeholder" style={{ maxWidth: '100%', height: 'auto' }} />
                            <div id='ourwork-row-9-article-info'>
                                <div className='blog-row-3-article-info'>
                                    <article>Insurance</article>
                                    <article className='ourwork-row-9-pfa-article'>Premier Financial Alliance</article>
                                    <article>How We Streamlined Premier Financial Alliance's Employee Operations</article>
                                </div>
                            </div>
                        </Link>
                    </div>

                    <div className='blog-row-3-card' id='ourwork-row-9-card' style={{ display: 'flex', justifyContent: 'center' }}>
                        <Link to="/case-studies/pearlx" style={{ textDecoration: 'none', cursor: 'pointer', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <img src={Blog2} alt="Placeholder" style={{ maxWidth: '100%', height: 'auto' }} />
                            <div id='ourwork-row-9-article-info'>
                                <div className='blog-row-3-article-info'>
                                    <article>Energy</article>
                                    <article>PearlX</article>
                                    <article>How We Built PearlX's State Of The Art Customer Portal</article>
                                </div>
                            </div>
                        </Link>
                    </div>

                    <div className='blog-row-3-card' id='ourwork-row-9-card' style={{ display: 'flex', justifyContent: 'center' }}>
                        <Link to="/case-studies/barclays" style={{ textDecoration: 'none', cursor: 'pointer', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <img src={Blog3} alt="Placeholder" style={{ maxWidth: '100%', height: 'auto' }} />
                            <div id='ourwork-row-9-article-info'>
                                <div className='blog-row-3-article-info'>
                                    <article>Banking</article>
                                    <article>Barclays Bank US</article>
                                    <article>How The Website Revamp And CMS We Implemented Enabled Barclay's to Cater to its Diverse Customers</article>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>

                <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <button id='ourwork-row-9-button' onClick={() => navigate("/case-studies")}>See all</button>
                </div>
            </section>            <div className='home-row-4'>
                <div className='home-row-4-top'>
                    <h1 className='home-row-4-top-header  '>How we can help you</h1>
                    {/* <p className='home-row-4-top-text'>We support you on all fronts:</p> */}
                </div>

                <div className='home-row-4-bottom'>
                    <div className='home-row-4-images'>
                        <img src={Consulting} alt="Consulting" className='consulting' />
                        <div>
                            <p className='home-row-4-image-headers'>Business consulting</p>
                            <p className='home-row-4-image-subheader'>Our experienced team of consultants is ready to guide you through every step of your business journey, from growth advice to rebranding and beyond.</p>
                        </div>
                    </div>
                    <div className='home-row-4-images'>
                        <img src={TechConsulting} alt="Consulting" className=' tech-consulting' />
                        <div>
                            <p className='home-row-4-image-headers'>Bespoke tech solutions</p>
                            <p className='home-row-4-image-subheader'>We empower you with a wide range of bespoke tech solutions with transparent value, from custom software development to generative AI.</p>
                        </div>
                    </div>
                    <div className='home-row-4-images'>
                        <img src={Entrprenuer} alt="Consulting" className=' entrepreneur' />
                        <div>
                            <p className='home-row-4-image-headers'>Entrepreneurial hub</p>
                            <p className='home-row-4-image-subheader'>We're your bridge to top-tier consultants, forward-thinking business owners, funders, and investors.</p>
                        </div>
                    </div>
                </div>
                <button className='lets-talk-button'>
                    <Link to="/contactus" className="navlink">Let's talk</Link>
                </button>


            </div>

            <section className='ourwork-row-11'>
                <div>
                    <h1>Our way of working</h1>
                    <p>It's not about having many resources; it's about having the right ones. With our proven method, top-notch team, and cutting-edge technology, there's no challenge too big for us to tackle. No two companies are the same. That's why we tailor our approach to your unique needs. Yet, our process, always involves this sequence of steps.</p>
                </div>
            </section>

            <section className='ourwork-row-10'>
                <img src={Dots} alt="Dots" className='ourwork-dots' />
                <img src={Hands} alt="Dots" className='ourwork-hands' />
                <div className='ourwork-row-10-header'>
                    <div>
                        <h1>What we can help <br className='home-row-7-header-br' /> you with</h1>
                        <p>We've helped businesses evolve for over a decade. We can predict your challenges, expedite your results, and help you seize growth opportunities.</p>
                    </div>
                </div>
                <div className='ourwork-row-10-content'>
                    <div>
                        <h3>Business & strategy consulting</h3>
                        <p>We'll be your strategic partners and help you manage your risk and performance</p>
                    </div>
                    <div>
                        <h3>Operational optimization</h3>
                        <p>We'll help you manage changes, reengineer your business processes, and transform your operations so they're as effective as can be.</p>
                    </div>
                    <div>
                        <h3>Marketing & branding support</h3>
                        <p>We'll support you with your branding and market positioning, optimizing the way you present yourself to your potential customers</p>
                    </div>

                </div>
                <p id='ourwork-row-10-p'> Our knowledge of modern software building frameworks, AI, ML, and generative AI tools, allows us to solve your most complex tech problems with ease. The possibilities are endless.</p>
                <div className='ourwork-row-10-content2'>
                    <div>
                        <h3>Customer experience & UX/UI</h3>

                        <p>We'll refine your user experience and craft intuitive, visually appealing interfaces to enhance every interaction your customers have with your brand.</p>
                    </div>
                    <div>
                        <h3>Web & mobile app development</h3>
                        <p>We're excited to deliver solutions that are both functional and innovative, whether it's by building a sleek website or a robust mobile application.</p>
                    </div>
                    <div>
                        <h3>Artificial Intelligence & machine learning</h3>
                        <p>We'll help you unlock new insights and make your operations more efficient than ever by harnessing the power of AI and ML.</p>
                    </div>
                    {/* <div>
                        <img src={Cube} alt="Cube" />
                        <h3>Data management</h3>
                    </div> */}
                </div>
                <div className='ourwork-row-10-content3'>
                    <div>
                        <h3>Languages & scripts</h3>
                        <p>JAVA, GO and Scala Technologies | JavaScript frameworks (i.e. angular, react, node, rekit, view) | .NET framework and Akka framework | Content Management Systems with specialization in Magnolia and Wordpress</p>
                    </div>
                    <div>
                        <h3>Databases, integrations & tools</h3>
                        <p>PostgreSQL, MongoDB, NoSQL, SnowFlake, SQL Server, Elastic Search, Pentaho BI, Okta, Firebase, Signrequest , Big Data and BI tools using Python, R, PowerBI, Tableau.</p>
                    </div>
                    <div>
                        <h3>Cloud & management Services</h3>
                        <p>Corda R3, Hyperledger, Ethereum | AWS, Digital Ocean, GCP, Azure | Docker, Kubernetes | FIS Profile Banking Core and Channels, Bottomline Digital Banking</p>
                    </div>

                </div>
                <p>You'll get much farther with the right connections. Here's how we can support you on this front:</p>
                <div className='ourwork-row-10-content4'>
                    <div>
                        <h3>Tech & advisory</h3>
                        <p>Our top consultants and tech advisors are ready to share the invaluable insights and guidance you need to make your moonshot a reality.</p>
                    </div>
                    <div>
                        <h3>Funding</h3>
                        <p>Plenty of investors in our community—who knows? Your business idea may be just the funding opportunity they're looking for.</p>
                    </div>
                    <div>
                        <h3>Networking</h3>
                        <p>Grow your network and influence by engaging with forward-thinking business owners, industry leaders, and key partners. We're ready to introduce you to our trusted partners and peers.</p>
                    </div>

                </div>
            </section>




            <section className='ourwork-row-12'>
                <div className='ourwork-row-12-content-top'>
                    <div className='ourwork-row-12-content'>
                        <img src={One} alt="One" />
                        <h4>Assessment</h4>
                        <p>We dive deep into your case and take on your challenges and ambitions as our own.</p>
                    </div>
                    <div className='ourwork-row-12-content'>
                        <img src={Two} alt="One" />
                        <h4>Creative <br /> problem-solving</h4>
                        <p>Now, we put our minds together to craft with an ideal strategy that puts your goals within reach.</p>
                    </div>
                    <div className='ourwork-row-12-content'>
                        <img src={Three} alt="One" />
                        <h4>Collaborative & transparent build</h4>
                        <p>We leverage our wealth of experience to seamlessly execute against our vision while keeping you updated with every step.</p>
                    </div>
                </div>
            </section>


            <section className='ourwork-row-12' id='ourwork-row-12-bottom-main'>

                <div className='ourwork-row-12-content-top' id='ourwork-row-12-content-bottom-container'>
                    <div className='ourwork-row-12-content' id='ourwork-row-12-content-bottom'>
                        <img src={Four} alt="One" />
                        <h4 id='ourwork-row-12-content-bottom-header'>Agile iteration <br className='ourwork-row-12-content-bottom-header-br'/> and testing</h4>
                        <p>We second your evolving needs as we test, integrate, build, and learn with you.</p>
                    </div>
                    <div className='ourwork-row-12-content' id='ourwork-row-12-content-bottom'>
                        <img src={Five} alt="One" />
                        <h4>Measuring success</h4>
                        <p>After our initial scope of work is completed, we work with you to measure our success against your goals.</p>
                    </div>
                    <div className='ourwork-row-12-content' id='ourwork-row-12-content-bottom'>
                        <img src={Six} alt="One" />
                        <h4>Future growth</h4>
                        <p>We ideate with you on the future state of your business to further support your growth goals.</p>
                    </div>
                </div>
            </section>                        <p className='ourwork-row-2-text'></p>

           

           <section className='ourwork-row-14 blog-row-14'>

                <h2>Get in touch</h2>
                <p>Reach out to us to gather  more information or <br className='blog-row-14-break'  id='ourwork-row-14-break'/>  set our wheels in motion.</p>
                <div className='ourwork-arrow-box blog-arrow-box' id='ourwork-row-14-arrow-box'>
                    <img src={Arrow} alt="arrow" className='ourwork-arrow' />
                    <button onClick={() => navigate("/contactus")}>Let's talk</button>
                </div>

            </section>

            {!isTablet ? (
                <section className='home-footer'>
                    <div className='home-footer-middle'>
                        <img src={Amalgam} alt="Amalgam" className='home-footer-amalgam' />
                        <Link to="/" className='home-footer-links'>Home</Link>
                        <Link to="/ourwork" className='home-footer-links'>Our Work</Link>
                        <Link to="/aboutus" className='home-footer-links'>About Us</Link>
                        <Link to="/case-studies" className='home-footer-links'>Case Studies</Link>
                        <Link to="/careers" className='home-footer-links'>Careers</Link>
                        <Link to="/startups" className='home-footer-links'>Launchpad</Link>
                        <Link to="/contactus" className='home-footer-links'>Contact Us</Link>
                        <img src={LinkedIn} alt="Instagram" className='home-footer-linkedin' />
                    </div>
                    <div className='home-footer-dividor'>
                        <div className='home-footer-policies'>
                            <p><Link to="/privacy-policy">Privacy Policy</Link></p>
                            <p><Link to="/terms-and-conditions">Terms and Conditions</Link></p>
                            <p><Link to="/cookie-policy">Cookie Policy</Link></p>
                        </div>
                    </div>
                </section>
            ) : (
                <section>
                    <div className="footer-minimal">
                        <div className="footer-content">
                            {/* <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '20px' }}>
                                <img src={Amalgam} alt="Amalgam" className="footer-logo" />
                                <img src={LinkedIn} alt="Instagram" className='home-footer-linkedin' style={{ alignSelf: "center" }} />
                            </div> */}
                            <div className="footer-top-row">
                                <Link to="/" className="footer-link">Home</Link>
                                <span className="footer-separator">•</span>
                                <Link to="/ourwork" className="footer-link">Our Work</Link>
                                <span className="footer-separator">•</span>
                                <Link to="/aboutus" className="footer-link">About Us</Link>
                                <span className="footer-separator">•</span>
                                <Link to="/case-studies" className="footer-link">Case Studies</Link>
                            </div>
                            <div className="footer-bottom-row">
                                <Link to="/startups" className="footer-link">Launchpad</Link>
                                <span className="footer-separator">•</span>
                                <Link to="/careers" className="footer-link">Careers</Link>
                                <span className="footer-separator">•</span>
                                <Link to="/contactus" className="footer-link">Contact</Link>
                            </div>
                        </div>
                    </div>

                    <div style={{
                        width: "80%",
                        height: "0px",
                        borderTop: "1px solid black",
                        backgroundColor: "white",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingBottom: "20px",
                        margin: "0 auto"
                    }}>
                    </div>
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "white",
                        gap: isMobile ? "5px" : "20px",
                        paddingBottom: "20px",
                        width: "100%",
                        padding: "0 10px 20px 10px",
                        textAlign: "center"
                    }}>
                        <Link to="/privacy-policy" style={{ textAlign: "center", color: "black", textDecoration: "none" }}>Privacy Policy</Link>
                        <span style={{ color: "black", fontSize: "14px" }}>|</span>
                        <Link to="/terms-and-conditions" style={{ color: "black", textDecoration: "none" }}>Terms and Conditions</Link>
                        <span style={{ color: "black", fontSize: "14px" }}>|</span>
                        <Link to="/cookie-policy" style={{ fontSize: "14px", color: "black", textDecoration: "none" }}>Cookie Policy</Link>
                    </div>
                </section>
            )}

        </div>
    )
}

export default Ourwork 